export const DEFAULT_TOAST_AUTO_CLOSE_MS = 5000;
